var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useGetRepairAndRebuildAdministrationQuery } from "@/store/api";
import { LoaderImage } from "@/utils/loader";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
export default function Repair() {
    var t = useTranslation(["Administration"]).t;
    var _a = useParams(), action = _a.action, type = _a.type;
    var _b = useGetRepairAndRebuildAdministrationQuery({ params: { action: action, type: type } }), repairAndRebuildData = _b.data, isLoading = _b.isLoading;
    var results = repairAndRebuildData === null || repairAndRebuildData === void 0 ? void 0 : repairAndRebuildData.data;
    var renderResults = function (items, isRepairAction) {
        return items === null || items === void 0 ? void 0 : items.map(function (item, index) { return (_jsx("p", __assign({ className: "text-sm" }, { children: isRepairAction
                ? t(item) !== item
                    ? t(item)
                    : item.charAt(0).toUpperCase() + item.slice(1)
                : item }), index)); });
    };
    return (_jsxs("div", __assign({ className: "p-10 relative overflow-auto" }, { children: [isLoading && _jsx(LoaderImage, {}), renderResults(results, true), _jsx("br", {}), _jsx(Link, __assign({ className: "py-5 text-[rgb(var(--color-blue-700))]", to: "/modules/Administration/Upgrade" }, { children: "Return to Administration page" }))] })));
}
